﻿const messages = {
  en: {
    translations: {
      validation: {
        required: "Required",
        invalid: "Invalid",
        tooShort: "Too short",
        tooLong: "Too long",
      },
      weekdays: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
          forcedLogout: "Your session was ended by an administrator.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        presence: {
          online: "Online",
          away: "Away",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "Unavailable",
          registered: "Registered",
          offline: "Offline",
        },
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
        extras: {
          searchPlaceholder: "Search by name",
          filters: "Filters",
          add: "Add",
          disconnectedTitle: "Connections disconnected unexpectedly",
          disconnectedDescription: "Some connections were disconnected. This can happen due to an expired session, instability or temporary access loss.",
          viewConnections: "View connections",
          activeTab: "Active",
          archivedTab: "Archived",
          connectionId: "Connection ID: #{{id}}",
          noDefaultQueue: "No default queue",
          emptyArchived: "No archived connection.",
          empty: "No connection found.",
          showingResults: "Showing {{visible}} of {{total}} results",
          pageLabel: "Page 1 of 1",
          view: "View",
          archive: "Archive",
          unarchive: "Restore",
          delete: "Delete",
          breadcrumb: "Connections > Add connection",
          addConnectionTitle: "Add connection",
          available: "Available",
          availableCount: "{{count}} available",
          limitReached: "Limit reached",
          createdConnection: "{{count}} connection created.",
          createdConnections: "{{count}} connections created.",
          contractToUse: "Subscribe to this connection to start using it.",
          usage: "Usage: {{count}}{{limit}}",
          newConnection: "New connection",
          request: "Request",
          blockedUnavailable: "Connection unavailable",
          blockedLimitTitle: "Limit reached for this connection",
          blockedNotContractedTitle: "This connection is not included in your plan",
          blockedComingSoonTitle: "This connection is still being prepared",
          blockedLimitMessage: "Your plan includes this connection, but the contracted limit has already been reached. Contact support to increase capacity.",
          blockedNotContractedMessage: "It looks like your current plan does not include this connection. Contact support to learn how to enable it on your account.",
          blockedComingSoonMessage: "This connection is included in the package, but the connector is not available in this version yet.",
          talkSupport: "Talk to support",
          archiveTitle: "Archive connection",
          archiveMessage: "This connection will leave the active list and remain available in the Archived tab.",
          unarchiveTitle: "Restore connection",
          unarchiveMessage: "This connection will return to the active connections list.",
          archivedSuccess: "Connection archived.",
          restoredSuccess: "Connection restored.",
          didMissing: "DID not provided",
          metaIdMissing: "Meta ID not provided",
          numberMissing: "Number not provided",
          configured: "Configured",
          configure: "Configure",
          connected: "Connected",
          connecting: "Connecting",
          connect: "Connect",
          reconnect: "Reconnect",
          disconnected: "Disconnected",
          pairing: "Pairing",
          unstable: "Unstable",
          pending: "Pending",
          groupActive: "Active",
          groupInactive: "Disabled"
        },
      },
      apiTools: {
        introTitle: "Operational integration tools",
        introText: "Configure and run API actions directly from the attendance flow, with security and auditability.",
        httpTitle: "HTTP actions",
        httpText: "Register actions such as second copy, unlock and service-order opening.",
        permissionsTitle: "Permissions",
        permissionsText: "User-based control with action-level restrictions.",
        auditTitle: "Audit",
        auditText: "Execution records to trace who ran each action, when and with what result.",
        wabaIntro: "Configure official credentials per connection and validate connectivity with Meta Cloud API.",
        loadingConnections: "Loading connections...",
        noWaba: "No WABA connection registered yet. Create a WABA connection in Connections > Add WhatsApp.",
        config: "Configuration",
        templates: "Templates",
        calls: "Calls",
        whatsappConnection: "WhatsApp connection",
        enableWaba: "Enable WABA on this connection",
        generate: "Generate",
        loading: "Loading...",
        saving: "Saving...",
        testing: "Testing...",
        saveWaba: "Save WABA",
        testConnection: "Test connection",
        updateList: "Refresh list",
        createTemplate: "Create template",
        updateCalls: "Refresh calls",
        close: "Close",
        reload: "Reload"
      },
      companyPage: {
        title: "Company",
        refresh: "Refresh",
        operationTitle: "Team operation",
        operationDescription: "Centralize the company's operational behavior in one place.",
        saveOperation: "Save operation",
        awayMinutes: "Time to mark away (minutes)",
        awayMinutesHelp: "After this time without activity, the attendant is marked away.",
        subjectRequired: "Ticket subject required",
        subjectRequiredHelp: "When enabled, the attendant must enter the subject before sending messages in the ticket.",
        autoResumeSla: "Automatically resume SLA",
        autoResumeSlaHelp: "When enabled, the SLA timer automatically resumes when the customer replies.",
        sharedQueue: "Allow shared queue for attendants",
        sharedQueueHelp: "When enabled, attendant users can see tickets from their own queue, even when not assigned to them.",
        loadPreviousTicketMessages: "Load messages from previous tickets",
        loadPreviousTicketMessagesHelp: "Scrolling up in the conversation keeps loading messages from the same contact earlier tickets. Can be allowed or denied per user.",
        previousTicketMessagesPageSize: "Messages per load",
        previousTicketMessagesPageSizeHelp: "Between 10 and 100. Applies to the whole conversation, not only the history.",
        pendingCloseByUser: "Allow attendants to close waiting tickets",
        pendingCloseByUserHelp: "When enabled, attendants can close tickets still in waiting status without accepting first. When disabled, only admins can do it.",
        previewPending: "Allow previewing waiting tickets",
        previewPendingHelp: "When enabled, attendants can open a preview of waiting tickets without accepting them.",
        recordingsPlayback: "Allow attendants to hear recordings",
        recordingsPlaybackHelp: "When enabled, attendants can play call recordings in tickets.",
        blockedTitle: "Blocked contacts",
        blockedDescription: "Define the message and automatic action for contacts and groups marked as blocked.",
        saveBlocked: "Save blocking",
        featureDisabled: "Feature disabled by superadmin for this company.",
        blockedMessage: "Message for blocked contact",
        blockedMessageHelp: "Message sent automatically when a blocked contact or group sends a message.",
        blockedAction: "Action for blocked contact",
        closeTicket: "Close ticket",
        keepPending: "Keep in queue",
        blockedCloseSubject: "Subject when closing blocked ticket",
        noSubject: "No subject",
        businessHoursTitle: "Business hours",
        businessHoursDescription: "Define the company's business hours, absence message and desired behavior outside hours or on holidays.",
        holidays: "Register holidays",
        saveHours: "Save hours",
        outOfHoursMessage: "Out-of-hours absence message",
        outOfHoursMessageHelp: "This message is sent automatically outside business hours. On holidays, the holiday message takes priority.",
        outOfHoursAction: "When contacted outside hours or on a holiday",
        day: "Day",
        active: "Active",
        start: "Start",
        end: "End",
        connectionsTitle: "Company connections",
        connectionsDescription: "Manage default queue, groups and main behavior for each connection.",
        newConnection: "New connection",
        editConnection: "Edit connection",
        defaultConnection: "Default connection",
        allowGroups: "Handle groups",
        defaultQueue: "Connection default queue",
        noDefaultQueue: "No default queue",
        availableQueues: "Queues available on this connection:",
        noLinkedQueue: "no linked queue",
        routedToDefaultQueue: "New tickets from this connection will be routed to the default queue.",
        keepCurrentQueueBehavior: "Without a default queue, the current queue selection behavior is kept.",
        saveConnection: "Save connection",
        activeDays: "{{count}} active days",
        noConfiguredDay: "No configured day"
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
          imported: "WhatsApp contact import completed.",
          invalidImportFile: "Select a CSV or TXT file to import.",
          fileImported:
            "Import finished. Imported: {{imported}} | Duplicates: {{skippedDuplicates}} | Invalid: {{skippedInvalid}}.",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          importPhone: "Import WhatsApp",
          importFile: "Import CSV/TXT",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          personType: "Person type",
          document: "CPF/CNPJ",
          email: "Email",
          actions: "Actions",
          viewHistory: "View contact history",
        },
        overview: {
          title: "Contact history",
          contactMeta: "Number: {{number}} | Email: {{email}}",
          ticketsTitle: "Contact tickets",
          noTickets: "No tickets found for this contact.",
          noSubject: "No subject",
          close: "Close",
          metrics: {
            total: "Total tickets",
            open: "In service",
            pending: "Waiting",
            closed: "Closed",
          },
          status: {
            open: "In service",
            pending: "Waiting",
            closed: "Closed",
          },
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          personType: "Registration type",
          document: "CPF/CNPJ",
          documentHelp: "Enter the contact CPF or CNPJ.",
          priorityQueue: "Priority queue",
          priorityQueueNone: "None (follow the connection queue)",
          priorityQueueHelp:
            "New conversations from this contact go straight to this queue, instead of the connection default queue or menu.",
          personTypeOptions: {
            notInformed: "Not informed",
            pf: "PF",
            pj: "PJ",
          },
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
          description: "Queue description",
          tags: "Queue tags",
          variablesHelp:
            "Variables: {{name}}, {{firstname}}, {{ticketId}} (ticket number) and {{protocol}} (date + number)",
          businessHoursTitle: "Queue-specific hours",
          useOwnBusinessHours: "Use custom hours for this queue",
          outOfHoursMessage: "Out-of-hours message",
          outOfHoursMessageHelp: "If empty, the company absence message is used.",
          outOfHoursAction: "Out-of-hours action",
          keepPending: "Keep in queue",
          closeTicket: "Close ticket",
          day: "Day",
          active: "Active",
          start: "Start",
          end: "End",
          distributionTitle: "Automatic distribution",
          distributionMode: "Distribute queue tickets",
          distributionModes: {
            off: "Do not distribute (agents pick from the queue)",
            round_robin: "Round robin (one each, in order)",
            least_busy: "Fewest ongoing tickets",
            longest_idle: "Longest without receiving a ticket",
            random: "Random",
          },
          distributionHelp:
            "A ticket waiting in this queue goes straight to an agent's In progress tab (with the accept message, if configured). Only online agents receive tickets; away and offline are skipped. Tickets a bot (n8n/Typebot) is answering are not distributed until the bot steps out.",
          distributionMaxPerUser: "Simultaneous tickets per agent",
          distributionMaxPerUserHelp:
            "0 = no limit. Agents at the limit receive nothing; the ticket waits in the queue.",
          distributionReassignMinutes: "Reassign if the agent does not reply within (minutes)",
          distributionReassignHelp:
            "0 = never reassign. Only until the agent replies: if the customer waits this long without a reply from whoever got the ticket, it goes to another online agent of the queue. Once the agent replies from the panel, the ticket stays with them. With nobody else available, it stays.",
        },
          buttons: {
            okAdd: "Add",
            okEdit: "Save",
            cancel: "Cancel",
          },
          success: "Queue saved successfully.",
        },
      extensionModal: {
        title: {
          add: "Add extension",
          edit: "Edit extension",
        },
        form: {
          extension: "SIP extension",
          extensionValidation: "Use numbers only (2 to 10 digits)",
          zoiperUserHint: "Zoiper username: {{value}}",
          label: "Description",
          user: "Agent",
          unassigned: "Unassigned",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Extension saved successfully.",
      },
      userModal: {
        title: {
          add: "Add user",
          refresh: "Refresh",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          language: "Language",
          languageOptions: {
            pt: "Portuguese",
            en: "English",
            es: "Spanish",
          },
          whatsapp: "Default Connection",
          sipUser: "SIP account",
          sipStatus: "SIP Status",
          sipPassword: "SIP password",
          enableSip: "Enable SIP",
          enableWabaCalling: "Allow WABA calls",
          enableWabaCallingHelp:
            "Allows the Call button to appear in this user's WABA tickets.",
          supervisorMode: "Supervisor mode",
          supervisorModeHelp:
            "Grants operational supervisor permissions without access to the administration menu.",
          internalChatDeleteDirect: "Delete direct internal chat conversation",
          internalChatDeleteDirectHelp:
            "Deleting removes the conversation and every message for both sides, with no way to undo it. Without this permission the user can still leave the conversation, which only clears their own list.",
          internalChatDeleteGroup: "Delete internal chat group",
          internalChatDeleteGroupHelp:
            "Deleting removes the group and its history for every member, with no way to undo it.",
          internalChatDeleteAdminHelp:
            "Administrators can already delete internal chat conversations by role.",
          queueVisibility: "See tickets from their queues",
          queueVisibilityCompany: "Follow the company setting",
          queueVisibilityAllow: "Allowed",
          queueVisibilityDeny: "Not allowed",
          queueVisibilityHelp:
            "Applies to tickets in the queues the user belongs to, including other agents tickets. Following the company uses the general option in Settings; the other two apply to this user only.",
          queueVisibilityAdminHelp:
            "Administrators already see every ticket in the company by role.",
          previousTicketMessages: "Load messages from previous tickets",
          previousTicketMessagesHelp:
            "Scrolling up in the conversation keeps loading messages from the same contact earlier tickets. Following the company uses the general option in Settings.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        tabs: {
          private: "Individuals",
          group: "Groups",
        },
        buttons: {
          newTicket: "New",
          search: "Search",
          filters: "Filters",
        },
        activeFiltersSummary: {
          singular: "{{count}} active filter",
          plural: "{{count}} active filters",
        },
        connectionAlert: {
          notifyAdmin: "Notify an administrator.",
          checkConnections: "Check the connections.",
          noConnections: "The company has no WhatsApp connection configured.",
          qrcode: "There is a WhatsApp connection waiting for QR Code.",
          connecting: "The WhatsApp connection is unstable right now.",
          inactive: "The company has no active WhatsApp connection.",
        },
        filters: {
          title: "Advanced filters",
          ticketId: "Ticket number",
          ticketIdPlaceholder: "e.g. 26385",
          subtitle:
            "Refine the operation by queue, agent, connection, date and tags without losing list context.",
          status: "Status",
          statusOptions: {
            active: "Active",
            open: "Working on",
            pending: "Queue",
            closed: "Resolved",
          },
          agent: "Agent",
          connection: "Connection",
          date: "Date",
          all: "All",
          allFemale: "All",
          hint:
            "Combine queue, agent, connection, date and tags to reach the right conversation faster.",
          clear: "Clear",
          cancel: "Cancel",
          apply: "Apply",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
        noQueue: "No queue",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        confirmations: {
          closePendingWithoutAccept:
            "Do you want to close without starting service?",
        },
        buttons: {
          accept: "Accept",
          closePending: "Close",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          profile: "My Profile",
          companies: "Companies",
          announcements: "Announcements",
          backups: "Backups",
          debugLogs: "System logs",
          dashboard: "Dashboard",
          attendance: "Attendance",
          attendanceBadgeUnread: "{{total}} with unread messages",
          attendanceBadgePending: "{{total}} waiting to be picked up",
          internalChat: "Internal chat",
          internalTickets: "Internal tickets",
          attendances: "Attendances",
          monitoring: "Monitoring",
          company: "Company",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          extensions: "Extensions",
          tags: "Tags",
          ticketSubjects: "Ticket subjects",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          language: {
            label: "Change language",
            options: {
              pt: "Portuguese",
              en: "English",
              es: "Spanish",
            },
          },
          sound: {
            enable: "Enable notification sounds",
            disable: "Mute notification sounds",
          },
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          description: "Description",
          tags: "Tags",
          businessHours: "Queue hours",
          actions: "Actions",
        },
        businessHours: {
          own: "Own",
          company: "Company",
        },
          buttons: {
            add: "Add queue",
          },
          toasts: {
            deleted: "Queue deleted successfully.",
          },
          confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      extensions: {
        title: "SIP Extensions",
        zoiperHint: "Zoiper username format: c{company}-{extension}. Example: c2-1001.",
        table: {
          extension: "Extension",
          zoiperUser: "Zoiper username",
          label: "Description",
          user: "Agent",
          status: "Status",
          actions: "Actions",
          unassigned: "Unassigned",
          active: "Active",
          inactive: "Inactive",
          sip: "SIP",
          sipOnline: "Online",
          sipOffline: "Offline",
          sipUnavailable: "Unavailable",
          sipUnqualified: "Not qualified",
        },
        summary: {
          label: "Extensions",
          unlimited: "Unlimited",
        },
        buttons: {
          add: "Add extension",
        },
        toasts: {
          deleted: "Extension deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete extension",
          deleteMessage: "Are you sure? This action cannot be reverted.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          status: "Status",
          whatsapp: "Default Connection",
          sipUser: "SIP account",
          sipStatus: "SIP Status",
          supervisor: "Supervisor",
          actions: "Actions",
        },
        supervisor: {
          enabled: "Enabled",
          disabled: "Disabled",
        },
        buttons: {
          add: "Add user",
          refresh: "Refresh",
          disconnect: "Disconnect user",
        },
        presence: {
          online: "Online",
          away: "Away",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "Unavailable",
          registered: "Registered",
          offline: "Offline",
        },
        toasts: {
          deleted: "User deleted successfully.",
          disconnected: "User disconnected successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure you want to end this user's session now?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        dropHint: "Drop the file to attach",
        dropTooManyFiles: "Only the first 5 files were attached.",
        captionPlaceholder: "Caption (optional)",
        captionPlaceholderMultiple: "Caption (goes with the first file)",
        filesCount: "{{count}} files",
      },
      internalTickets: {
        labels: {
          priority: { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" },
          status: { open: "Open", in_progress: "In progress", waiting: "Waiting for third party", done: "Done", cancelled: "Cancelled" },
          sla: { unscheduled: "No SLA", on_time: "On time", due_soon: "Due soon", overdue: "Overdue", completed: "Completed" },
        },
        page: {
          title: "Internal tickets",
          buttons: { new: "New internal ticket", refresh: "Refresh", clearFilters: "Clear filters", openAttendance: "Open attendance", edit: "Edit" },
          intro: { title: "Internal operation linked to customers and attendances", subtitle: "Track SLA, priority and owner without mixing internal execution with the customer conversation." },
          metrics: { total: "Internal tickets", dueSoon: "Due soon", overdue: "Overdue" },
          filters: { search: "Search", status: "Status", allActive: "All (active)", all: "All", mine: "My internal tickets", unassigned: "Unassigned" },
          card: { noDescription: "No additional description.", linkedTicket: "Linked attendance", linkedClient: "Linked customer", noLink: "No customer or attendance link", responsible: "Owner", notDefined: "Not defined", slaUnset: "not configured", attention: "Attention", createdBy: "Created by {{name}} on {{date}}", createdAt: "Created on {{date}}" },
          empty: { filtered: "No internal ticket found with the current filters. Try clearing the filters.", default: "No internal ticket found." },
        },
        dialog: {
          title: { add: "New internal ticket", edit: "Edit internal ticket" },
          meta: { protocol: "Protocol", client: "Customer", attendance: "Attendance", notLinked: "not linked", createdBy: "Created by {{name}} on {{date}}", createdAt: "Created on {{date}}" },
          fields: { noName: "No name", linkedTicket: "Linked attendance", ticketId: "Attendance (optional ID)", client: "Customer (optional)", title: "Title", priority: "Priority", description: "Description", status: "Status", responsible: "Owner", noResponsible: "Unassigned", finalComment: "Final comment", newComment: "New comment" },
          helpers: { ticketId: "Fill in if you want to link to a specific attendance.", client: "Search by name, number or document (minimum 2 characters).", finalCommentRequired: "Required to complete the internal ticket.", finalCommentOptional: "Optional to complement the closure." },
          placeholders: { finalComment: "Describe the closure to register it in history." },
          sections: { comments: "Comments", history: "History" },
          quickComments: { customerReturn: "Waiting for customer response", thirdParty: "Waiting for supplier/third party", technicalReview: "Under technical review", waitingValidation: "Action completed, waiting for validation", internalAlignment: "New internal alignment needed" },
          history: { loading: "Loading history...", system: "System", field: "Field", empty: "empty", noEvents: "There are no registered events yet." },
          toasts: { missingTitle: "Enter a title for the internal ticket.", missingResponsible: "Assign an owner before completing the internal ticket.", missingFinalComment: "Add a final comment to complete the internal ticket.", missingLink: "Link the internal ticket to an attendance and/or customer.", updated: "Internal ticket updated.", created: "Internal ticket created.", missingComment: "Enter a comment to add to history.", commentAdded: "Comment added." },
          buttons: { cancel: "Cancel", okAdd: "Create internal ticket", okEdit: "Save changes", addComment: "Add comment" },
        },
      },
      tags: {
        title: "Tags",
        table: {
          name: "Name",
          color: "Color",
          actions: "Actions",
        },
        buttons: {
          add: "New tag",
        },
        toasts: {
          deleted: "Tag removed successfully.",
        },
        confirmationModal: {
          deleteTitle: "Remove tag {{name}}?",
          deleteMessage: "This action removes the tag from registration and linked tickets.",
        },
      },
      tagModal: {
        title: {
          add: "New tag",
          edit: "Edit tag",
        },
        form: {
          name: "Name",
          color: "Color",
        },
        buttons: {
          okAdd: "Create tag",
          okEdit: "Save changes",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
      },
      ticketSubjects: {
        title: "Ticket subjects",
        table: {
          subject: "Subject",
          status: "Status",
          dashboard: "Dashboard",
          actions: "Actions",
        },
        buttons: {
          add: "New subject",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        dashboard: {
          count: "Count",
          ignore: "Ignore",
        },
        toasts: {
          deleted: "Subject removed successfully.",
        },
        confirmationModal: {
          deleteTitle: "Remove subject {{name}}?",
          deleteMessage: "This action removes the subject from the closing list.",
        },
      },
      ticketSubjectModal: {
        title: {
          add: "New subject",
          edit: "Edit subject - ID #{{id}}",
        },
        form: {
          subject: "Subject",
          active: "Active",
          countInDashboard: "Count in dashboard",
        },
        buttons: {
          okAdd: "Create subject",
          okEdit: "Save changes",
          cancel: "Cancel",
        },
        success: "Subject saved successfully.",
      },
      contactDrawer: {
        header: "Contact details",
        mainInfo: "Registration data",
        personType: "Registration type",
        document: "CPF/CNPJ",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        edit: "Edit",
        delete: "Delete",
        reply: "Reply",
        editTitle: "Edit message",
        save: "Save",
        cancel: "Cancel",
        edited: "Edited",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_MESSAGE_FOUND: "Message not found.",
        ERR_MESSAGE_TOO_LONG: "The edited message exceeds the allowed limit.",
        ERR_MESSAGE_EDIT_NOT_ALLOWED: "This message cannot be edited.",
        ERR_MESSAGE_EDIT_WINDOW_EXPIRED: "WhatsApp no longer allows this message to be edited.",
        ERR_MESSAGE_EDIT_TYPE_NOT_SUPPORTED: "This message type cannot be edited.",
        ERR_MESSAGE_EDIT_UNCHANGED: "The edited text has no changes.",
        ERR_MESSAGE_EDIT_CHANNEL_NOT_SUPPORTED: "This channel does not support message editing.",
        ERR_MESSAGE_DELETE_NOT_ALLOWED: "This message cannot be deleted.",
        ERR_MESSAGE_DELETE_CHANNEL_NOT_SUPPORTED: "This channel does not support message deletion.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Invalid username or password.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check the connection or the media format.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_CANNOT_DISCONNECT_SELF:
          "You cannot disconnect your own user with this action.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_CONTACT_IMPORT_FILE_REQUIRED:
          "Send a CSV or TXT file to import contacts.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_TAG_FOUND: "No tag found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_NO_EXTENSION_FOUND: "No extension found with this ID.",
        ERR_EXTENSION_ALREADY_EXISTS:
          "There is already an extension with this number.",
        ERR_EXTENSION_GLOBAL_CONFLICT:
          "This extension is already being used by another active SIP company.",
        ERR_USER_ALREADY_HAS_ACTIVE_EXTENSION:
          "This agent already has an active extension.",
        ERR_SIP_PASSWORD_REQUIRED:
          "Set the agent SIP password before activating/assigning the extension.",
        ERR_EXTENSION_INVALID:
          "Invalid extension. Use only numbers with 2 to 10 digits.",
        ERR_SIP_EXTENSION_LIMIT_REACHED:
          "SIP extension limit reached for this company.",
        ERR_NO_EXTERNAL_NUMBER_FOUND:
          "No external number found with this ID.",
        ERR_EXTERNAL_NUMBER_ALREADY_EXISTS:
          "There is already an external number with this value.",
        ERR_EXTERNAL_NUMBER_INVALID:
          "Invalid external number. Use digits with optional leading +.",
        ERR_EXTERNAL_NUMBER_DIRECTION_INVALID:
          "Invalid direction for external number.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_TICKET_SUBJECT_REQUIRED:
          "Please enter the ticket subject before sending messages.",
        ERR_TICKET_RESOLUTION_REQUIRED:
          "Please enter a short summary before resolving the ticket.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_PRIORITY_QUEUE_NOT_FOUND: "The selected priority queue no longer exists.",
        ERR_QUEUE_INVALID_DISTRIBUTION:
          "Invalid automatic distribution: check the mode, the per-agent limit (0 to 999) and the minutes (0 to 1440).",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_LICENSE_EXPIRED:
          "License expired. Contact support to renew the subscription.",
        ERR_LICENSE_NOT_FOUND:
          "License not found. Verify the configured LICENSE_KEY.",
        ERR_LICENSE_BINDING_MISMATCH:
          "License is bound to another environment. Clear binding and validate again.",
          ERR_BACKEND_UNREACHABLE:
            "Could not connect to backend. Check URL, port and CORS.",
          ERR_BACKEND_HTTPS_HTTP_MISMATCH:
            "Frontend is HTTPS and backend is HTTP. Use HTTP or enable HTTPS on backend.",
          ERR_API_TOOL_DOCUMENT_REQUIRED:
            "This action requires a valid CPF/CNPJ on the contact.",
          ERR_API_TOOL_DOCUMENT_INVALID:
            "Invalid CPF/CNPJ for this action. Review the contact record.",
          ERR_API_TOOL_RESULT_TEMPLATE_INVALID:
            "Invalid result template. Review the Mustache fields used.",
          ERR_API_TOOL_RESPONSE_MAPPING_INVALID:
            "Invalid response variable mapping. Review the JSON provided.",
          ERR_API_TOOL_BODY_INVALID_JSON:
            "Invalid body template: malformed JSON after applying variables.",
        },
    },
  },
};

export { messages };



